import axios from '../request/http';

const home = {
     // 首页banner图列表
     bannerList(params) {
        return axios.get("/admin/operation/banner/list",{params});
    },
    // 添加编辑banner
    addOrUpdBanner(data){
        return axios.post("/admin/operation/banner/edit", data );
    },
     // 删除banner
     delOrUpdBanner(params){
        return axios.get("/admin/operation/banner/update", {params} );
    },
    // 分享图列表
    shareList(params) {
        return axios.get("/admin/operation/share-img/list",{params});
    },
    // 新增编辑分享图
    addOrUpdShare(data){
        return axios.post("/admin/operation/share-img/edit", data );
    },
    // 删除分享图
    delOrUpdShare(params){
        return axios.get("/admin/operation/share-img/update", {params} );
    },
    // 会员列表
    getVip(params){
        return axios.get("/admin/vip/list", {params} );
    },
    // 会员状态更改
    addVip(data){
        return axios.post("/admin/vip/edit", data );
    },
    

}

export default home;


// WEBPACK FOOTER //
// ./src/api/home.js